<template>
  <div>
    <el-form class="formStyle" :inline="true" style="margin-top: 5px;margin-left: 5px" v-show="isShow.show">
      <span v-show="blkTypeGroupId=='02'">
          <el-form-item style="width: 40px" v-if="isShow.switch">
            <el-switch size="small" v-model="blkTypeGroupId" @change="switchBlcokType" active-value="02"
                       inactive-value="04"></el-switch>
          </el-form-item>
          <el-form-item label="单位:" style="width: 210px">
            <el-select v-model="glqIdx" @change="select_glq"  size="small" filterable>
              <el-option
                  v-for="(item,index) in blcokData"
                  :key="index"
                  :label="item.label"
                  :value="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="type!='alogorithm'&&isShow.yqt" label="油气田:" style="width: 150px">
            <el-select v-model="ytIdx" @change="select_yt" size="small" filterable>
              <el-option
                  v-for="(item,index) in blcokData[glqIdx]!=undefined ? blcokData[glqIdx].children : []"
                  :key="index"
                  :label="item.label"
                  :value="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="!isShow.yjcg&&type!='alogorithm'&&isShowQK" label="区块:" style="width: 150px">
            <el-select v-model="qkIdx" @change="select_qk" size="small" filterable>
              <el-option
                  v-for="(item,index) in  blcokData[glqIdx]!=undefined && blcokData[glqIdx].children[ytIdx]!=undefined ? blcokData[glqIdx].children[ytIdx].children : []"
                  :key="index"
                  :label="item.label"
                  :value="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="单井:" style="width: 150px" v-if="isShow.well&&type!='alogorithm'&&type!='wellgroup'">
            <el-select v-model="well" @change="select_well" size="small" filterable clearable>
              <el-option
                  v-for="item in welldata"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label"
              />
            </el-select>
          </el-form-item>
        </span>
      <span v-show="blkTypeGroupId=='04'">
          <el-form-item style="width: 40px" v-if="isShow.switch">
            <el-switch size="small" v-model="blkTypeGroupId" @change="switchBlcokType" active-value="02"
                       inactive-value="04"></el-switch>
          </el-form-item>
          <el-form-item label="个人井组:" style="width: 210px">
            <el-select v-model="jzIdx" @change="select_grjz" @visible-change="getBlock(false)" size="small" filterable>
              <el-option
                  v-for="(item,index) in userBlcokData"
                  :key="index"
                  :label="item.label"
                  :value="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单井:" v-if="isShow.well" style="width: 150px">
            <el-select v-model="well" @change="select_grp_well" size="small" filterable clearable>
              <el-option
                  v-for="item in welldata"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="width: 45px;margin-right: 20px">
            <el-button size="mini" type="primary" @click="userBlcokConfig">配置</el-button>
          </el-form-item>
        </span>
<!--      <span v-if="isShow.yjcg">-->
<!--        <el-form-item label="类型：" style="width: 210px" v-if="isShow.wdlxSet">-->
<!--          <el-cascader-->
<!--              v-model="wdlxSet"-->
<!--              :options="lxSelOpTions"-->
<!--              size="small"-->
<!--              filterable-->
<!--              clearable-->
<!--          />-->
<!--        </el-form-item>-->
<!--        <el-form-item label="后缀:" style="width: 120px" v-if="isShow.suffix">-->
<!--          <el-select v-model="suffix" size="small" filterable clearable>-->
<!--            <el-option-->
<!--                v-for="item in suffixList"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value"-->
<!--            />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="条件检索:" style="width: 300px" v-if="isShow.condition">-->
<!--           <el-input-->
<!--               v-model="conditionText"-->
<!--               style="padding-top: 5px"-->
<!--               clearable-->
<!--               size="small">-->
<!--             <template #prepend>-->
<!--               <el-select v-model="conditionField" size="small" style="width: 115px">-->
<!--                 <el-option-->
<!--                     v-for="item in  conditionList"-->
<!--                     :key="item.value"-->
<!--                     :label="item.label"-->
<!--                     :value="item.value"-->
<!--                 /></el-select>-->
<!--             </template>-->
<!--           </el-input>-->
<!--        </el-form-item>-->
<!--         <el-form-item label="状态:" style="width: 120px" v-if="isShow.state">-->
<!--          <el-select v-model="state" size="small" filterable clearable>-->
<!--            <el-option-->
<!--                v-for="item in stateList"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value"-->
<!--            />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--      </span>-->
    </el-form>

    <!--配置井组弹出框-->
    <div v-dialogDrag>
      <el-dialog
          v-model="isUserBlcokConfig"
          title="配置井组"
          width="250px">
        <el-row>
          <el-col :span="16">
            <el-input
                placeholder="输入关键字进行过滤"
                v-model="filterText">
            </el-input>
          </el-col>
          <el-col :span="7" :offset="1" style="padding-top: 6px">
            <el-button size="mini" type="primary" @click="onClickUserNodeAdd(userBlcokDataAll[0])">新增</el-button>
          </el-col>
        </el-row>
        <el-scrollbar :height="'calc(50vh - 176px)'">
          <el-tree
              :data="userBlcokData"
              :props="defaultProps"
              node-key="id"
              default-expand-all
              :filter-node-method="filterNode"
              ref="tree">
            <template #default="{ node }">
                <span class="custom-tree-node">
                  <i class="el-icon-s-home"></i><span>{{ node.label }}</span>
                </span>
              <span v-if="blkTypeGroupId=='04'">
                  <i class="small-operation-btn el-icon-plus" v-if=" node.data.pid=='0'" @click="onClickUserNodeAdd(node.data)"/>
                  <i class="small-operation-btn el-icon-edit " v-if="node.data.pid!='0'" @click="onClickUserNodeRename(node.data)"/>
                  <i class="small-operation-btn el-icon-delete" v-if="node.data.pid!='0'" @click=" onClickUserNodeDel(node.data)"/>
              </span>
            </template>
          </el-tree>
        </el-scrollbar>
      </el-dialog>
    </div>
    <!--    个人井组选井弹出框-->
    <div v-dialogDrag>
      <el-dialog
          v-model="selectionUserBlock"
          title="选井"
          width="650px"
          :destroy-on-close="true">
        <el-form :inline="true" label-width="90px">
          <el-form-item label="名称：">
            <el-input size="small" v-model="userBlocks.name"></el-input>
          </el-form-item>
          <el-form-item label="主井：">
            <el-select v-model="userBlocks.wellPkey" filterable size="small" style="width: 92%">
              <el-option v-for="item in userBlocks.wells"
                         :key="item"
                         :label="item"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区块：">
            <el-input size="small" v-model="userBlocks.blockFilterText" placeholder="筛选区块"></el-input>
            <el-scrollbar height="260px">
              <el-tree
                  class="filter-tree"
                  :data="userBlockData"
                  :props="defaultProps"
                  node-key="BLOCK_ID"
                  show-checkbox
                  @check="handleBlockCheckUser"
                  ref="userBlockTree"
                  :filter-node-method="userBlocksFilterNode"
                  :default-expanded-keys="blockExpandedKeys"
                  :default-checked-keys="blockCheckedKeyList">
              </el-tree>
            </el-scrollbar>
          </el-form-item>
          <el-form-item label="单井：">
            <el-input size="small" v-model="userBlocks.wellFilterText" placeholder="筛选井"></el-input>
            <el-scrollbar height="260px">
              <el-tree
                  class="filter-tree"
                  :data="userWellData"
                  :props="defaultProps"
                  node-key="id"
                  show-checkbox
                  default-expand-all
                  :expand-on-click-node="false"
                  @check="handleWellCheckUser"
                  ref="userWellTree"
                  :filter-node-method="userBlocksFilterNode"
                  :default-expanded-keys="userBlocks.wellCheckedKeys"
                  :default-checked-keys="userBlocks.wellCheckedKeys">
              </el-tree>
            </el-scrollbar>
          </el-form-item>
        </el-form>
        <template #footer>
      <span class="dialog-footer">
        <el-button @click="selectionUserBlock = false">取消</el-button>
        <el-button type="primary" @click="addUserBlock">确认</el-button>
      </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {ElMessage, ElMessageBox} from "element-plus";

export default {
  name: "blockSelect",
  props:{
    templateInfo: {
      default: {}
    },
    type:{
      default: ""
    },
  },
  data() {
    return {
      isShowQK:true,//区块
      isShow:{
        switch:false,//切换按钮
        well:true,//单井
        yjcg:false,//研究成果页面按钮
        wdlxSet:true,//类型
        suffix:true,//后缀
        condition:true,//条件检索
        state:true,//状态
        show:true,//是否需要显示所有选择
        yqt:true//油气田
      },//控制按钮显示
      blkTypeGroupId:"02",//区块类别
      blcokData: [
        {children: [{children: []}],}
      ],//全部区块数据（地质单元）
      userBlcokData:[],//个人井组列表
      blockList:[],//选择区块列表
      checkedBlock:{},//勾选区块列表
      glqIdx: 0,//管理区
      ytIdx: 0,//油田
      qkIdx:0,//区块
      well:"",//单井
      jzIdx:0,//个人井组
      fullBankWellData:[],//全部单井信息
      welldata:[],//单井列表
      lyqtUserInfoUserId:"",//用户id

      //个人井组配置相关参数
      isUserBlcokConfig:false,//配置井组弹出框标识
      filterText:'',
      userBlcokDataAll: [],//个人井组列表（父子结构）
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      selectionUserBlock:false,//个人井组选井弹出框标识
      userBlockData:[],//接收用户权限区块数据
      userWellData:[],//接收用户权限井数据
      checkedBlockUser:{},//接受个人井组选井界面勾选区块数据
      userBlocks:{
        id:"",//井组id（更新有值，新增无值）
        name:"",//井组名称
        wells:[],//勾选井列表
        wellBlockIds:[],//勾选井对应的区块id列表
        wellCheckedKeys:[],//勾选井数据 id集合，用于打开时的数据勾选展示
        wellFilterText:"",//井名称检索文本
        blockCheckedKeys:[],//勾选区块数据 id集合，用于打开时的数据勾选展示
        blockFilterText:"",//区块名称检索文本
        pid:"",//父节点id
        wellPkey:"",//主井名称
      },//添加个人井组相关数据
      blockExpandedKeys:[],//区块tree默认展开集合
      blockCheckedKeyList:[],//区块tree默认勾选集合

      //研究成果相关参数
      wdlxSet:null,//选择的研究成果类型
      lxSelOpTions:[],//研究成果类型
      lxSelOpTionsTemp:[
        {
          ISLEAF:0,
          id:1,
          label:"文档资料",
          value:"wd",
          children: [],
        },
        {
          ISLEAF:0,
          id:2,
          label:"成果图件",
          value:"tj",
          children: [],
        },
        {
          ISLEAF:0,
          id:3,
          label:"软件工区",
          value:"gq",
          children: [],
        },
      ],//研究成果类型模板
      wdlxSelOptions:[],//研究成果类型列表(文档)
      gqlxSelOptions:[],//研究成果类型列表(工区)
      tjlxSelOptions:[],//研究成果类型列表(图件)
      suffix:null,//选择后缀
      suffixList:[
        {
          label:"jpg",
          value:"jpg"
        },
        {
          label:"png",
          value:"png"
        },
        {
          label:"pdf",
          value:"pdf"
        },
        {
          label:"zip",
          value:"zip"
        }
      ],//后缀列表
      conditionText:"",//条件检索文本
      conditionField:"gfwdname",//条件检索选择字段
      conditionList:[
        {
          value:"gfwdname",
          label:"规范文件名"
        },
        {
          value:"wdname",
          label:"原始文件名"
        },
        {
          value:"cjr",
          label:"编制人"
        },
        {
          value:"shr",
          label:"审核人"
        }
      ],//条件检索字段列表
      state:"",//状态
      stateList:[
        {
          label:"已归档",
          value:"已归档"
        },
        {
          label:"待送审",
          value:"待送审"
        },
        {
          label:"待一审",
          value:"待一审"
        },
        {
          label:"待终审",
          value:"待终审"
        },
        {
          label:"已驳回",
          value:"已驳回"
        }
      ],//状态列表
    }
  },
  mounted(){
    let lyqtUserInfo = JSON.parse(localStorage.getItem("lyqtUserInfo"));
    this.lyqtUserInfoUserId=lyqtUserInfo.userId;
    this.$store.state.blockQueryFilter = [];//切换页面后，清空筛选条件
    this.judgeType();
    // if(this.blkTypeGroupId != '04') this.switchBlcokType()
    this.getBlock(true);//获取区块数据（银行，个人井组）
    // this.fetchWDLXData();
  },
  methods: {
    //类型判断,todo 屏蔽后，不报错
    judgeType(){
      this.blkTypeGroupId = '02'
      console.log("blktypeeee:",this.type)
      //研究成果综合展示模块
      if (this.templateInfo!=undefined && this.templateInfo.moduleid=="7F5756DD008345D78012745632D6EE95"){
        this.isShow.switch=false;
        this.isShow.well=false;
        this.isShow.yjcg=true;
        this.isShow.state=false;
      }
      //文档资料 上传模块
      if (this.templateInfo!=undefined && this.templateInfo.moduleid=="C9AD9619FEA24AF1BAFC0D81868C0551"){
        this.isShow.switch=false;
        this.isShow.well=false;
        this.isShow.yjcg=true;
        this.isShow.suffix=false;
        this.isShow.condition=false;
      }
      //成果图件 上传模块
      if (this.templateInfo!=undefined && this.templateInfo.moduleid=="E89AAE2AD0334DE5965F088AB09FF57B"){
        this.isShow.switch=false;
        this.isShow.well=false;
        this.isShow.yjcg=true;
        this.isShow.suffix=false;
        this.isShow.condition=false;
      }
      //软件工区 上传模块
      if (this.templateInfo!=undefined && this.templateInfo.moduleid=="DB013DA7B44B45C5997ED97B06238864"){
        this.isShow.switch=false;
        this.isShow.well=false;
        this.isShow.yjcg=true;
        this.isShow.suffix=false;
        this.isShow.condition=false;
      }

      if (this.templateInfo!=undefined && this.templateInfo.moduleid=="iosLise"){
        this.isShow.switch=false;
        this.isShow.well=this.type!=undefined&&this.type=='GIS'?true:false;
        this.isShow.yjcg=false;
        this.isShow.suffix=false;
        this.isShow.condition=false;
      }
      if(this.templateInfo!=undefined && this.templateInfo.moduleid=="fenceView"){
        this.isShow.switch=false;
        this.isShow.well=false;
        this.isShow.yjcg=false;
        this.isShow.suffix=false;
        this.isShow.condition=false;
      }
      if(this.templateInfo!=undefined && (this.templateInfo.moduleid=="5955c85eb4064ba981a6594872a816d0" ||
            this.templateInfo.moduleid=="ae75237f3f6c498fbb621a9e65095d6f")){
        this.isShow.switch=false;
        this.isShow.well=false;
        this.isShow.yjcg=false;
        this.isShow.suffix=false;
        this.isShow.condition=false;
        this.isShow.show = false;
      }
      if(this.templateInfo!=undefined && (this.templateInfo.type == "table_upload_scheme" ||
          this.templateInfo.type == "table_assess" ||
          this.templateInfo.type == "table_assess_obj" ||
          this.templateInfo.moduleid=="a2ecb45de2844e02a1ecad12165a55c4" ||
          this.templateInfo.moduleid=="c78575952fec411883148e6965517135" ||
          this.templateInfo.moduleid=="ed1462a839434eb0ad9089e7396ba4a5" ||
          this.templateInfo.moduleid=="37cacba87dd843c99a79ac1d1a7be1ef" ||
          this.templateInfo.moduleid=="e017ef7756044d3a810729b5b109f5d3" ||
          this.templateInfo.moduleid=="4790649B9B6343388D02E255EB3876B1" ||
          this.templateInfo.moduleid=="A24844FA50C3443A81FE6FB0A76EDE20" ||
          this.templateInfo.moduleid=="6F70256711EE4B5DA7328CFA4B801C60" ||
          this.templateInfo.moduleid=="7b2896c772f7401482ce6bd8c89d370d")){
        this.isShow.switch=false;
        this.isShow.well=false;
        this.isShowQK = false;
        this.isShow.yqt = false;
      }
      if(this.type == 'wellgroup' && this.blkTypeGroupId=='04'){
        this.well = "";
        this.isShow.well = false;
      }
      if(this.$route.name != undefined && this.$route.name.length>3){
        let routeNameLeftStr = this.$route.name.substring(0,3);
        if(routeNameLeftStr == "1-7" || routeNameLeftStr == "2-5" || routeNameLeftStr == "2-6" || routeNameLeftStr == "2-7"){
          this.isShow.well = false;
          if(routeNameLeftStr !== "1-7"){
            this.isShowQK = false;
          }
        }
        routeNameLeftStr = this.$route.name.substring(0,4);
        if(routeNameLeftStr == "1-10"){
          this.isShow.switch=false;
          this.blkTypeGroupId = '04';
          this.getUserWellData();
        }
      }
      //打开没有单井选择的页面时，默认清空单井信息
      if (this.isShow.well==false){
        localStorage.removeItem("blockSelectWells");
        this.$nextTick(() => {
          this.well="";
          this.saveSelectBlock();
        }, 100)
      }
    },
    //获取区块数据，并初始化赋值赋值
    getBlock(init){
      console.log("getblock",init)
      // if(init) this.blkTypeGroupId = localStorage.getItem("blockType");
      let storageBlkType = localStorage.getItem("blockType");
      if(init) localStorage.setItem("blockType", this.blkTypeGroupId);
      //获取银行区块
      if (this.blkTypeGroupId=='02' || init){
        if (this.blcokData.length == 1 && this.blockDatas != undefined && this.blockDatas.length != 0) {
          console.log("vuex获取区块")
          this.blcokData = this.blockDatas[0].children;
          if(this.blcokData.length>0) {
            if (this.blkTypeGroupId === '02') {
              let selectBlock = localStorage.getItem("selectBlock");
              if (selectBlock != null && selectBlock != undefined) {
                selectBlock = JSON.parse(selectBlock);
                console.log("seelectblc1", selectBlock)
                let curglqIdx = selectBlock.glqIdx != undefined?selectBlock.glqIdx:0;
                let curytIdx = selectBlock.ytIdx != undefined?selectBlock.ytIdx:0;
                let curqkIdx = selectBlock.qkIdx != undefined?selectBlock.qkIdx:0;
                this.jzIdx = selectBlock.jzIdx != undefined?selectBlock.jzIdx:0;

                this.selectWithoutSetWell(curglqIdx,curytIdx,curqkIdx);

                if(selectBlock.well !== "") {
                  if (this.blkTypeGroupId === storageBlkType) {
                    this.well = selectBlock.well;
                    this.select_well(this.well)
                  }
                }
                console.log("seelectblc2", selectBlock)
              }
            }
          }
        }
        else {
          console.log("后台加载区块")
          this.fetchData();
        }
      }
      //获取个人井组列表
      if (this.blkTypeGroupId=='04' && this.userBlcokData.length==0 || init){
        this.getUserBlock();
      }
      //获取井数据
      if (init) {
        this.fetchWellData();//获取所有井数据
        if (this.blkTypeGroupId == '04')
          this.getUserWellData();//获取个人井组井数据
      }
      //下拉框初始化赋值
      if (init){
        let selectBlock = localStorage.getItem("selectBlock");
        if (selectBlock != null && selectBlock != undefined) {
          selectBlock = JSON.parse(selectBlock);
          console.log(selectBlock)
          //this.blkTypeGroupId = selectBlock.blkTypeGroupId;
          selectBlock.blkTypeGroupId = this.blkTypeGroupId;
          if(this.blkTypeGroupId === '04') {
            this.glqIdx = selectBlock.glqIdx;
            this.ytIdx = selectBlock.ytIdx;
            this.qkIdx = selectBlock.qkIdx;
            this.well = selectBlock.well;
            this.jzIdx = selectBlock.jzIdx;
          }
        }
        if (this.blkTypeGroupId == null || this.blkTypeGroupId==undefined) this.blkTypeGroupId = "02";
      }
    },
    //获取区块数据（银行）
    fetchData() {
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankGeoUnit",
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          this.fetchDataALl(res.data[0].children)
          this.fetchDataALls(res.data[0])
          this.blcokData= res.data[0].children;
          this.$store.state.blockData = [];//清空vuex中的保存信息
          this.$store.state.blockData = res.data;//将信息存入vuex中
          if(this.blcokData.length>0) {
            let storageBlkType = localStorage.getItem("blockType");
            if (this.blkTypeGroupId === storageBlkType && this.blkTypeGroupId === '02') {
              let selectBlock = localStorage.getItem("selectBlock");
              if (selectBlock != null && selectBlock != undefined) {
                selectBlock = JSON.parse(selectBlock);
                console.log("seelectblc1", selectBlock)
                let curglqIdx = selectBlock.glqIdx != undefined?selectBlock.glqIdx:0;
                let curytIdx = selectBlock.ytIdx != undefined?selectBlock.ytIdx:0;
                let curqkIdx = selectBlock.qkIdx != undefined?selectBlock.qkIdx:0;
                this.selectWithoutSetWell(curglqIdx,curytIdx,curqkIdx);
                this.well = selectBlock.well;
                this.select_well(this.well)
                console.log("seelectblc2", selectBlock)
              }
            }
          }
          // console.log("区块：",res);
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    //区块树添加”全区块“等节点
    fetchDataALl(data) {
      let all = {};
      all.label = "全区块";
      all.ISLEAF = 2;
      all.children = [];
      if (data[0].PROJECT_TYPE == "ORG") {
        all.label = "塔里木油田";
      }
      if (data[0].PROJECT_TYPE == "ATSVZB100000976" && data[0].ISLEAF == 0) {
        all.label = "全油田";
      }
      if (all.label == "全区块") {
        all.children = JSON.parse(JSON.stringify(data));
      }
      data.push(all);
      let len = data.length;
      data.unshift(data.splice(len - 1, 1)[0]);//置顶最后一条数据
      for (let i = 1; i < data.length; i++) {
        if (data[i].ISLEAF == 0) {
          for (let j = 0; j < data[i].children.length; j++) {
            all.children.push(data[i].children[j]);
          }
          this.fetchDataALl(data[i].children);
        }
      }
    },
    //“塔里木油田”，”全油田“节点添加“全油田”，“全区块”节点
    fetchDataALls(data) {
      if (data.label == "塔里木油田" && data.ISLEAF == 2) {
        // console.log("找到塔里木油田",data)
        let all = {};
        all.label = "全油田";
        all.children = [];
        all.ISLEAF = 3;
        let allChl = {};
        allChl.label = "全区块";
        allChl.ISLEAF = 3;
        allChl.children = [];
        let dataChildren = data.children;

        for (let i = 0; i < dataChildren.length; i++) {
          if (dataChildren[i].children == undefined)
            continue
          for (let j = 1; j < dataChildren[i].children.length; j++) {
            all.children.push(dataChildren[i].children[j]);
            allChl.children.push(dataChildren[i].children[j]);
          }
        }
        //全油田 里面 添加 全区块
        all.children.push(allChl);
        all.children.unshift(all.children.splice(all.children.length - 1, 1)[0]);//置顶最后一条数据
        //塔里木油田 里添加 全油田
        dataChildren.push(all);
        let len = dataChildren.length;
        dataChildren.unshift(dataChildren.splice(len - 1, 1)[0]);//置顶最后一条数据
      }
      if (data.label == "全油田" && data.ISLEAF == 2) {
        // console.log("找到全油田",data)
        let all = {};
        all.label = "全区块";
        all.children = [];
        all.ISLEAF = 3;
        let dataChildren = data.children;
        for (let i = 0; i < dataChildren.length; i++) {
          all.children.push(dataChildren[i]);
        }
        dataChildren.push(all);
        let len = dataChildren.length;
        dataChildren.unshift(dataChildren.splice(len - 1, 1)[0]);//置顶最后一条数据
      }
      if (data.children!=undefined){
        let dataChildren=data.children;
        for (let i = 0; i < dataChildren.length; i++) {
          // if (dataChildren[i].ISLEAF == undefined || dataChildren[i].ISLEAF==0) {
          //   console.log("666",data.label)
          //   this.fetchDataALls(dataChildren[i]);
          // }
          if (dataChildren[i].ISLEAF == 2 || dataChildren[i].ISLEAF==0) {
            this.fetchDataALls(dataChildren[i]);
          }
        }
      }
    },
    //获取个人井组
    getUserBlock(){
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userBlockData"+`?userId=${this.lyqtUserInfoUserId}`,
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          this.userBlcokData= res.data[0].children;
          this.userBlcokDataAll= res.data;
          if(this.userBlcokData !=undefined && this.userBlcokData.length>0) {
            let storageBlkType = localStorage.getItem("blockType");
            if (this.blkTypeGroupId === storageBlkType && this.blkTypeGroupId === '04') {
              let selectBlock = localStorage.getItem("selectBlock");
              if (selectBlock != null && selectBlock != undefined) {
                selectBlock = JSON.parse(selectBlock);
                console.log("seelectblc", selectBlock)
                if (selectBlock.jzIdx != undefined) {
                  this.jzIdx = selectBlock.jzIdx;
                  this.select_grjz(selectBlock.jzIdx);
                } else {
                  this.select_grjz(0);
                }
              }
            }
          }
          // this.$store.state.blockData = [];//清空vuex中的保存信息
          // this.$store.state.blockData = res.data;//将信息存入vuex中
          console.log("个人井组：",res);
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取对应个人井组的井数据
    getUserWellData() {
      let that = this;
      that.welldata=[];
      console.log("currentSelBlk", that.checkedBlock)
      if (JSON.stringify(that.checkedBlock) == "{}") {
        let checkedLocal = localStorage.getItem("checkedBlock");
        if (checkedLocal == null || checkedLocal == undefined)
          checkedLocal = {};
        this.checkedBlock = JSON.parse(checkedLocal);
        console.log("checkedBlock", that.checkedBlock)
      }

      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/userWellData",
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: that.checkedBlock
      }).then((res) => {
        if (res.status === 200 && res.data.length > 0 && res.data[0].children.length > 0) {
          console.log(res);
          let resData=res.data[0].children;
          that.welldata = [];
          for (let i = 0; i< resData.length; i++) {
            resData[i].children.forEach(item=>{
              that.welldata.push(item);
            });
          }
          console.log("设计公司给上课还是：",this.welldata)
          that.$store.state.wellgroupData = [];
          that.$store.state.wellgroupData = this.welldata;//将井数据存储vuex中
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    //切换区块类型
    switchBlcokType(){
      //加载井数据
      if (this.blkTypeGroupId=='02')
        this.setWellDataByCheckedBlk();
      if (this.blkTypeGroupId=='04')
        this.getUserWellData();
      localStorage.setItem("blockType", this.blkTypeGroupId);
      this.saveSelectBlock();
    },
    selectWithoutSetWell(glqVal,ytVal,qkVal){
      console.log("feee",this.fullBankWellData)
      this.glqIdx = glqVal;
      this.ytIdx = ytVal;
      this.qkIdx = qkVal;
      if(qkVal!==0){
        this.handleBlockData(this.blcokData[glqVal].children[ytVal].children[qkVal]);
      }
      else if(ytVal !=0){
        this.handleBlockData(this.blcokData[glqVal].children[ytVal]);
      }
      else{
        this.handleBlockData(this.blcokData[glqVal]);
      }

      if(this.fullBankWellData != undefined && this.fullBankWellData.length>0){
        this.setWellDataByCheckedBlk();
      }
    },
    //选择管理区触发
    select_glq(val){
      // this.ytIdx=null;
      // if (val==0)
        this.ytIdx=0;
      this.qkIdx=0;
      this.well="";
      this.welldata=[];
      this.handleBlockData(this.blcokData[val]);
      this.setWellDataByCheckedBlk();
    },
    //选择油田触发
    select_yt(val){
      this.qkIdx=0;
      this.well="";
      this.welldata=[];
      this.handleBlockData(this.blcokData[this.glqIdx].children[val]);
      this.setWellDataByCheckedBlk();
    },
    //选择区块触发
    select_qk(val){
      this.well="";
      this.handleBlockData(this.blcokData[this.glqIdx].children[this.ytIdx].children[val]);
      this.setWellDataByCheckedBlk();
    },
    //井组选择单井触发
    select_grp_well(val){
      console.log('66666',val,this.jzIdx,this.userBlcokData[this.jzIdx],this.$store.state.wellgroupData)
      if(val.length == 0){
        this.handleBlockData(this.userBlcokData[this.jzIdx]);
        // this.$store.state.wellgroupData = this.welldata;
      }
      else {
        this.$store.state.wellData = [];
        this.$store.state.wellData.push(val);
      }
      this.saveSelectBlock();
    },
    //选择单井触发
    select_well(val){
      //存储选中单井号到vuex中
      this.$store.state.wellData = [];
      this.$store.state.wellData.push(val);
      console.log("wellVal",val)
      localStorage.setItem("blockSelectWells", JSON.stringify(this.$store.state.wellData));
      this.saveSelectBlock();
    },
    //选择个人井组触发
    select_grjz(val){
      this.well="";
      this.welldata=[];
      console.log("grpVal",this.userBlcokData[val])
      this.handleBlockData(this.userBlcokData[val]);
      this.getUserWellData();
    },

    //获取所有井数据
    fetchWellData() {
      if (this.getFullBankWellDatas != undefined && this.getFullBankWellDatas.length != 0) {
        console.log("vuex获取所有井")
        this.fullBankWellData = this.getFullBankWellDatas;
        this.setWellDataByCheckedBlk();
      }
      else {
        console.log("后台加载所有井")
        let jwtSession = localStorage.getItem("lyqtJwt");
        if (jwtSession == null) jwtSession = "";
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellDataWithJwt",
          method: 'POST',
          headers: {
            "Authorization": "Bearer " + jwtSession
          },
        }).then((res) => {
          if (res.status === 200) {
            this.fullBankWellData = res.data;
            this.$store.state.fullBankWellData = [];//清空vuex中的保存信息
            this.$store.state.fullBankWellData = res.data;//将信息存入vuex中
            // console.log("井数据：",res.data)
            this.setWellDataByCheckedBlk();
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    //筛选当前选中区块的井数据
    setWellDataByCheckedBlk(){
      let checkedWellData = JSON.parse(JSON.stringify(this.fullBankWellData));
      let checkedBlock=localStorage.getItem("checkedBlock");
      if(!(checkedBlock == null || checkedBlock == undefined || Object.keys(checkedBlock).length == 0)) {
        checkedBlock=JSON.parse(checkedBlock);
        for(let idxa=0;idxa<checkedWellData.length;idxa++){
          let rootWellNode = checkedWellData[idxa];
          if(rootWellNode.children!=null && rootWellNode.children.length>0){
            for(let idxb=rootWellNode.children.length-1;idxb>=0;idxb--){
              let jbNode = rootWellNode.children[idxb];
              if(jbNode.children!=null && jbNode.children.length>0){
                for(let idxc=jbNode.children.length-1;idxc>=0;idxc--){
                  let wellNode = jbNode.children[idxc];
                  let qkidVal = wellNode.QK_ID;
                  let isNeedRemove = true;
                  for (let key in checkedBlock) {
                    if (qkidVal == checkedBlock[key].value) {
                      isNeedRemove = false;
                      break;
                    }
                  }
                  if(isNeedRemove){
                    jbNode.children.splice(idxc,1)
                  }
                }
                if(jbNode.children.length==0){
                  rootWellNode.children.splice(idxb,1)
                }
              }
            }
          }
        }
      }
      this.$store.state.wellgroupData = [];
      this.$store.state.wellgroupData = checkedWellData;//将井数据存储vuex中
      console.log("区块单井：",checkedWellData)
      this.welldata = [];
      if (checkedWellData[0].children != undefined && checkedWellData[0].children.length > 0) {
        for (let i = 0; i < checkedWellData[0].children.length; i++) {
          if (checkedWellData[0].children[i].children == undefined)
            continue
          let dataWells = checkedWellData[0].children[i].children;
          dataWells.forEach(item => {
            let well = {};
            well.id = item.WELL_ID;
            well.label = item.WELL_LEGAL_NAME;
            well.name = item.WELL_COMMON_NAME;
            this.welldata.push(well);
          })
        }
      }
      // console.log("单井：",this.welldata)
    },
    //拼接 wells，checkedBlkList的数据并保存
    handleBlockData(data) {
      if(data == undefined) return;
      this.blockList = [
        data.label,
        [],
        "qk",
        this.blkTypeGroupId
      ];
      this.checkedBlock = {};
      this.getBlockChild(data);
      console.log("wells:", this.blockList)
      console.log("checkedBlkList:", this.checkedBlock)

      //将当前选中区块设置为全局
      this.$store.state.wellData = [];//清空vuex中的保存信息
      this.$store.state.wellData = this.blockList;//将信息存入vuex中
      localStorage.setItem("wells", JSON.stringify(this.blockList));
      localStorage.setItem("checkedBlock", JSON.stringify(this.checkedBlock));
      localStorage.removeItem("blockSelectWells");//删除保存的单井信息
      this.saveSelectBlock();
    },
    //拼接 checkedBlock 列表
    getBlockChild(data){
      if (data.ISLEAF == 1 || data.children == undefined) {
        this.blockList[1].push(data.label);
        this.checkedBlock[data.BLOCK_ID] = data;
      }
      else {
        data.children.forEach(item => {
          if (item.ISLEAF == 0 && item.children != undefined && item.children.length > 0) {
            this.getBlockChild(item)
          }
          else {
            this.blockList[1].push(item.label);
            this.checkedBlock[item.BLOCK_ID] = item;
          }
        })
      }
    },
    //保存所有选择框的值
    saveSelectBlock(){
      let  selectBlock={
        blkTypeGroupId:this.blkTypeGroupId,//区块标识  银行/个人井组
        glqIdx:this.glqIdx,//管理区
        ytIdx:this.ytIdx,//油田
        qkIdx:this.qkIdx,//区块
        well:this.well,//单井
        jzIdx:this.jzIdx,//个人井组
      };
      localStorage.setItem("selectBlock", JSON.stringify(selectBlock));
      console.log("selectBlockSave:",selectBlock)
    },

    //———————————个人井组配置————————
    //点击配置按钮（个人井组）
    userBlcokConfig(){
      console.log(1);
      this.isUserBlcokConfig=!this.isUserBlcokConfig;
    },
    //过滤节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //添加个人井组
    onClickUserNodeAdd(data){
      //清空数据
      this.userBlocks.id="";
      this.userBlocks.name="";
      this.userBlocks.blockCheckedKeys=[];
      this.userBlocks.wellCheckedKeys=[];
      this.userBlocks.wellBlockIds=[];
      this.userBlocks.wells=[];
      this.userBlocks.pid=data.value;//获取父id
      this.userBlocks.wellPkey="";
      this.blockExpandedKeys=["GEUTTL100000320"];//区块tree默认展开”塔里木油田“
      this.blockCheckedKeyList=[];
      this.checkedBlockUser={};
      this.getUserBlockData();//获取区块数据
      this.getUserWell();//获取井数据
      this.selectionUserBlock=true;
    },
    //修改个人井组
    onClickUserNodeRename(data){
      console.log(data)
      this.userBlocks.id=data.value;//获取井组id
      this.userBlocks.pid=data.pid;//获取井组父id
      this.userBlocks.name=data.label;//获取井组名称
      this.userBlocks.wells=data.wells;//获取井组名称
      this.userBlocks.blockCheckedKeys=data.blockCheckedKeys;//获取勾选区块id
      this.userBlocks.wellCheckedKeys=data.wellCheckedKeys;//获取勾选井id
      this.userBlocks.wellBlockIds=data.wellBlockIds;//获取勾选井对应区块id
      this.userBlocks.wellPkey = data.wellPkey!=undefined ?  data.wellPkey : "";//获取主井
      this.checkedBlockUser = {};//根据勾选区块获取区块id
      if (this.userBlocks.blockCheckedKeys != null) {
        this.userBlocks.blockCheckedKeys.forEach(item => {
          this.checkedBlockUser[item] = "";
        })
      }
      this.blockExpandedKeys = data.blockCheckedKeys;//获取区块tree默认展开id
      this.blockCheckedKeyList = data.blockCheckedKeys;//获取区块tree默认勾选id
      this.getUserBlockData();//获取区块数据
      this.getUserWell();//获取井数据
      this.selectionUserBlock=true;
    },
    //删除个人井组
    onClickUserNodeDel(data){
      let url=process.env.VUE_APP_SERVER + "/dataprovider/systemdata/actionUserWell";//axios地址
      ElMessageBox.confirm(
          '确定删除？',
          '警告',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning',
          }
      ).then(()=>{
        axios.post(url,{
          id:data.value,
        }).then(res=>{
          // console.log(res);
          ElMessage.success(res.data.message);
          this.getUserBlock();//刷新个人井组
        }).catch(err=>{
          console.log(err);
        })
      }).catch(()=>{})
    },
    //获取用户权限区块
    getUserBlockData(){
      let that = this;
      that.blkprogressvisible = true;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankGeoUnit",
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          this.userBlockData = res.data;
          console.log("区块：",res.data);
        }
        that.blkprogressvisible = false;
      }).catch((err) => {
        console.log(err)
        that.blkprogressvisible = false;
      })
    },
    //获取用户勾选区块对应井数据
    getUserWell(){
      // let checkedBlock={"0AED13F2D11142FFB3A75CBF6B0B1C47":{}};//默认获取东河1区块井数据
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/bankWellData",
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: this.checkedBlockUser
      }).then((res) => {
        console.log(res);
        this.userWellData=res.data;
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    //获取勾选油田数据
    handleBlockCheckUser(currentNode, checkedObjs) {
      //拼接查询井数据的区块信息
      this.checkedBlockUser = {};
      let checkednodes = checkedObjs.checkedNodes;
      if (checkednodes.length > 0) {
        for (let nodeIdx in checkedObjs.checkedNodes) {
          let data = checkednodes[nodeIdx];
          //判断是否是最小的节点
          if (data.ISLEAF === 1) {
            this.checkedBlockUser[data.BLOCK_ID] = data;
          }
        }
      }

      this.userBlocks.blockCheckedKeys = checkedObjs.checkedKeys;//记录勾选区块id
      //获取区块tree默认展开,勾选id
      if (this.userBlocks.blockCheckedKeys.length==0){
        this.blockExpandedKeys=["237f0197-b323-49c6-8a74-4c955d1c5c5d"];
        this.blockCheckedKeyList=[];
      }
      else {
        this.blockExpandedKeys = checkedObjs.checkedKeys;
        this.blockCheckedKeyList = checkedObjs.checkedKeys;
      }
      //判断新勾选的区块是否包含已勾选井，保留对应区块已勾选的井
      let wellGrupOneData = [];//井名
      let wellBlockIds = [];//井对应的区块id
      let checkedKeys = [];//勾选井id
      let blockCheckedKeysStr=JSON.stringify(this.userBlocks.blockCheckedKeys);
      this.userBlocks.wellBlockIds.forEach((item,idx)=>{
        if (blockCheckedKeysStr.indexOf(item)!=-1){
          wellGrupOneData.push(this.userBlocks.wells[idx]); //获取井名称
          wellBlockIds.push(this.userBlocks.wellBlockIds[idx]);//获取井对应区块id
          checkedKeys.push(this.userBlocks.wellCheckedKeys[idx]);//获取井id
        }
      })
      let isNotPkey=true;//判断当前勾选井中是否存在主井
      wellGrupOneData.forEach(item=>{
        if (item==this.userBlocks.wellPkey){
          isNotPkey=false;
          return
        }
      });
      if (isNotPkey)
        this.userBlocks.wellPkey="";
      this.userBlocks.wells = wellGrupOneData;
      this.userBlocks.wellBlockIds = wellBlockIds;
      this.userBlocks.wellCheckedKeys = checkedKeys;//记录勾选井id
      this.getUserWell();//刷新井数据
    },
    //获取勾选个人井组数据
    handleWellCheckUser(currentNode, checkedObjs) {
      console.log(currentNode)
      console.log(checkedObjs)
      let wellGrupOneData = [];//井名
      let wellBlockIds = [];//井对应的区块id
      let checkedKeys = [];//勾选井id
      let checkednodes = checkedObjs.checkedNodes;

      for (let nodeIdx in checkedObjs.checkedNodes) {
        let data = checkednodes[nodeIdx];
        //判断是否是最小的节点
        if (!data.children) {
          wellGrupOneData.push(data.label); //获取井名称
          wellBlockIds.push(data.LEVBLKID);//获取井对应区块id
          checkedKeys.push(data.id);//获取井id
        }
      }
      let isNotPkey=true;//判断当前勾选井中是否存在主井
      wellGrupOneData.forEach(item=>{
        if (item==this.userBlocks.wellPkey){
          isNotPkey=false;
          return
        }
      });
      if (isNotPkey)
        this.userBlocks.wellPkey="";
      this.userBlocks.wells = wellGrupOneData;
      this.userBlocks.wellBlockIds = wellBlockIds;
      this.userBlocks.wellCheckedKeys = checkedKeys;//记录勾选井id
    },
    //tree组件 搜索筛选 过滤节点——个人井组选井弹出框
    userBlocksFilterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //选井弹出框确认（添加个人井组）
    addUserBlock(){
      console.log("新增井组：",this.userBlocks);
      //数据验证判断
      if (this.userBlocks.name==""){
        ElMessage.info("井组名称不能为空")
        return
      }
      if (this.userBlocks.wells.length==0){
        ElMessage.info("请勾选井")
        return
      }
      if (this.userBlcokData != undefined && this.userBlcokData != null && this.userBlcokData.length > 0) {
        let isVerify = true;
        this.userBlcokData.forEach(item => {
          if (item.label == this.userBlocks.name && item.value != this.userBlocks.id) {
            ElMessage.info("井组名称不能重复");
            isVerify = false;
            return
          }
        })
        if (!isVerify)
          return
      }
      if (this.userBlocks.wellPkey==""){
        ElMessage.info("请选择主井")
        return;
      }
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/addUserBlock", {
        "data": this.userBlocks,
        "userId": this.lyqtUserInfoUserId,
      }).then(res => {
        // console.log(res);
        this.getUserBlock();//刷新个人井组
        ElMessage.success(res.data.message);
      }).catch(err => {
        console.log(err);
      })
      this.selectionUserBlock=false;
    },

    //———————————研究成果————————
    //获取类型列表(文档)
    fetchWDLXData() {
      // console.log("获取研究成果类型列表")
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/wdljgxData",
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          this.wdlxSelOptions = res.data;
          this.wdlxSelOptions.forEach(item=>{
            this.lxSelOpTionsTemp[0].children.push(item);
          })
          // console.log(res);
          this.fetchTJLXData();
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取类型列表(图件)
    fetchTJLXData() {
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/tjljgxData",
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          this.tjlxSelOptions = res.data;
          this.tjlxSelOptions.forEach(item=>{
            this.lxSelOpTionsTemp[1].children.push(item);
          })
          // console.log(res);
          this.fetchGQLXData();
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取类型列表(工区)
    fetchGQLXData() {
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/gqljgxData",
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          this.gqlxSelOptions = res.data;
          this.gqlxSelOptions.forEach(item=>{
            this.lxSelOpTionsTemp[2].children.push(item);
          })
          // console.log(res);
          this.lxSelOpTions=this.lxSelOpTionsTemp;
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    //封装筛选查询条件
    queryFilter() {
      //创建筛选查询条件模板
      let queryFilter = {
        code: 0,//组别唯一序列号
        logic: "",//与其他组别的关系
        show: false,//折叠状态
        children: [],
      };
      let childrenTemp = {
        logic: "",//逻辑
        field: "",//字段
        symbol: "",//条件
        value: "",//值
        code: 0//条件唯一序列号
      };
      //添加 类型 筛选条件
      if (this.wdlxSet != "" && this.wdlxSet != null && this.wdlxSet.length > 0) {
        let flid = this.wdlxSet[this.wdlxSet.length - 1]
        let children = JSON.parse(JSON.stringify(childrenTemp))
        children.value = flid;
        children.field = "flid";
        children.symbol = "=";
        queryFilter.children.push(children);
      }
      //添加 后缀 筛选条件
      if (this.suffix != "" && this.suffix != null) {
        let children = JSON.parse(JSON.stringify(childrenTemp))
        children.code = 1;
        if (queryFilter.children.length > 0)
          children.logic = "AND";
        children.value = "%" + this.suffix + "%";
        children.field = "wdname";
        children.symbol = "like";
        queryFilter.children.push(children);
      }
      //添加 条件检索 筛选条件
      if (this.conditionText != "" && this.conditionText != null) {
        let children = JSON.parse(JSON.stringify(childrenTemp))
        children.code = 2;
        if (queryFilter.children.length > 0)
          children.logic = "AND";
        children.value = "%" + this.conditionText + "%";
        children.field = this.conditionField;
        children.symbol = "like";
        queryFilter.children.push(children);
      }
      //都为空
      if (queryFilter.children.length == 0) {
        queryFilter = [];
      }
      this.$store.state.blockQueryFilter = queryFilter;//将信息存入vuex中
      console.log(queryFilter)
    },
    //封装筛选查询条件
    queryFilterUpload() {
      //创建筛选查询条件模板
      let queryFilter = {
        code: 0,//组别唯一序列号
        logic: "",//与其他组别的关系
        show: false,//折叠状态
        children: [],
      };
      let childrenTemp = {
        logic: "",//逻辑
        field: "",//字段
        symbol: "",//条件
        value: "",//值
        code: 0//条件唯一序列号
      };
      //添加 类型 筛选条件
      if (this.state != "" && this.state != null) {
        let children = JSON.parse(JSON.stringify(childrenTemp))
        children.value = this.state;
        children.field = "sh_stat";
        children.symbol = "=";
        queryFilter.children.push(children);
      }
      //为空
      if (queryFilter.children.length == 0) {
        queryFilter = [];
      }
      this.$store.state.blockQueryFilter = queryFilter;//将信息存入vuex中
      console.log(queryFilter)
    },

  },
  computed:{
    //计算单井数据变化
    blockDatas(){
      return this.$store.getters.getBlockData;
    },
    //计算单井数据变化
    getFullBankWellDatas(){
      return this.$store.getters.getFullBankWellData;
    },
  },
  watch: {
    blockDatas(){
      console.log("5555555555555555555555")
      console.log(this.blockDatas)
      //初始化进入，没有缓存时，默认选择“全管理区”
      if (localStorage.getItem("checkedBlock") == undefined) {
        this.handleBlockData(this.blcokData[this.glqIdx]);
      }
    },
    filterText(val) {
      if(val == undefined) return;
      this.$refs.tree.filter(val);
    },
    //监听 类型 值变化
    wdlxSet() {
      console.log(this.wdlxSet);
      this.queryFilter();
    },
    //监听 后缀 值变化
    suffix() {
      console.log(this.suffix);
      this.queryFilter();
    },
    //监听 条件检索，文本 值变化
    conditionText() {
      console.log(this.conditionText);
      this.queryFilter();
    },
    //监听 条件检索，字段 值变化
    conditionField() {
      console.log(this.conditionField);
      this.queryFilter();
    },
    //监听 状态 值变化
    state() {
      console.log(this.state);
      this.queryFilterUpload();
    },
    //监听个人井组 选区块筛选内容变化
    "userBlocks.blockFilterText"(val){
      if(val == undefined) return;
      this.$refs.userBlockTree.filter(val);
    },
    //监听个人井组 选井筛选内容变化
    "userBlocks.wellFilterText"(val){
      if(val == undefined) return;
      this.$refs.userWellTree.filter(val);
    },
  }
}
</script>

<style scoped>
.formStyle{
  font-family: "方正大黑简体";
  /*font-size: 100px;*/
  font-weight: bold;
  /*margin-top: 10px;*/
}
.floatDiv{
  position: absolute;
  left: 42%;
  top: 100px;
  filter:alpha(Opacity=100);-moz-opacity:1.0;opacity: 1.0;
  z-index: 5;
  /*height: 300px;*/
  width: 180px;
  border: 2px solid #000;
}
</style>